import { Component } from 'react'

/**
 * Catches render errors in children and shows fallback instead of blank screen.
 * Usage: <ErrorBoundary fallback={<div>Something went wrong</div>}>{children}</ErrorBoundary>
 */
class ErrorBoundary extends Component {
  state = { hasError: false, error: null, errorInfo: null }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    this.setState({ errorInfo: info })
    console.error('ErrorBoundary caught:', error, info)
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback
      const { error, errorInfo } = this.state
      return (
        <div className="page-container" style={{ padding: '2rem', color: 'var(--text-primary)', fontFamily: 'var(--font-display)' }}>
          <h1>Something went wrong</h1>
          <p style={{ marginTop: '1rem', color: 'var(--text-muted)' }}>Try refreshing the page.</p>
          {error && (
            <pre style={{ marginTop: '1.5rem', padding: '1rem', background: 'var(--bg-secondary)', overflow: 'auto', fontSize: '0.85rem', textAlign: 'left' }}>
              {error.toString()}
              {errorInfo?.componentStack && `\n\n${errorInfo.componentStack}`}
            </pre>
          )}
          <button type="button" onClick={() => window.location.reload()} style={{ marginTop: '1.5rem', padding: '0.5rem 1rem', cursor: 'pointer' }}>Refresh page</button>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
